<header class="row site-header mx-0" data-testid="focus-navbar-root">
  <div class="site-identity">
    <a class="upfront-focus-text" data-testid="focus-navbar-logo-link"  [ngStyle]="{ 'pointer-events': userStatus === 'On Call' ? 'none' : 'auto' }" href="{{appsRedirectUrl}}">
      <img data-testid="focus-navbar-logo-image" class="upfront-logo " src="assets/images/Upfront Icon/Upfront_Color.svg" alt="upfront_logo" />
    </a>

    <div class="search-holder" data-testid="focus-navbar-search-root"><i class="fa fa-search cursor-pointer" aria-hidden="true" data-testid="focus-navbar-searchbtn-searchpatient" (click)="searchPatient()"></i>
      <input type="text" name="search" maxlength="50" data-testid="focus-navbar-patient-search-text"
        placeholder="Search for a {{ 'patient' | customPatientLabel }} by ID, First Name, Last Name, Email, DOB, Phone Number"
        [(ngModel)]="searchString" (keydown.enter)="searchPatient()" (ngModelChange)="searchInput($event)">
    </div>
  </div>
  <nav class="site-navigation" data-testid="focus-navbar-nav">
    <ul class="nav-items" data-testid="focus-navbar-items-list" (click)="navigationClicked()">
      <!-- <li *ngIf="allPermission && allPermission.FocusHomeGet" routerLink="/focus" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">Home</li> -->
      <li id="nav-patients" data-testid="focus-navbar-patients-nav" *ngIf="allPermission && allPermission.GetPatientDetails">
      <a routerLink="/focus/patients" routerLinkActive="active" data-testid="focus-navbar-patients-link">
        {{ 'Patient' | customPatientLabel }}
      </a>
    </li>
      <li id="nav-inbox" data-testid="focus-navbar-inbox-nav" *ngIf="allPermission && allPermission.InboxFocusGet">
        <a routerLink="/focus/inbox" routerLinkActive="active" data-testid="focus-navbar-inbox-link">
          Inbox
        </a>
      </li>
      <li id="nav-campaign" data-testid="focus-navbar-campaign-nav" *ngIf="allPermission && allPermission.PostPatientFileUpload"
        >
        <a routerLink="/focus/campaign" routerLinkActive="active" data-testid="focus-navbar-campaign-link">
          Campaign
        </a>
      </li>
       <li id="nav-dashboards" data-testid="focus-navbar-dashboards-nav"
        *ngIf="allPermission && allPermission.FocusDashboardGet && (allSubPermission.FocusDashboardLiveVoice || allSubPermission.FocusDashboardDigitalEngagement || allSubPermission.FocusDashboardRealtime)">
      <a [routerLink]="'/focus/dashboard/' + defaultDashboardRoute" routerLinkActive="active" data-testid="focus-navbar-dashboards-link">Dashboards</a>
    </li>
      <!-- <li routerLink="/focus/realTimeDashboard" routerLinkActive="active">Statistics</li> -->
      <li id="nav-reports" data-testid="focus-navbar-reports-nav" *ngIf="allPermission && allPermission.FocusReportsGet">
        <a data-testid="focus-navbar-reports-link" [routerLink]="reportsPath" [class.active]="isReportsRouteActive">
          Reports
        </a> 
      </li>
       <li id="nav-admin" data-testid="focus-navbar-admin-nav" *ngIf="allPermission && allPermission.ClientAdminTab">
      <a routerLink="/focus/admin" routerLinkActive="active" data-testid="focus-navbar-admin-link">Admin</a>
    </li>
    <li>
            <button id="nav-notifications" data-testid="focus-navbar-notificationsbtn-togglefilter" class="notification-bell" #filterOrigin="cdkOverlayOrigin" cdkOverlayOrigin  aria-label="Open filters"
              (click)="toggleFilter()">
              <img data-testid="focus-navbar-notifications-bell-image" src="../../../../assets/images/client-messaging/bellIcon.svg" alt="Notification Bell"
                >
              <ng-container *ngIf="notificationService.blink$ | async">
                <span class="blink-icon" data-testid="focus-navbar-notifications-blink-indicator"></span>
              </ng-container>
            </button>

           <ng-template cdk-connected-overlay 
             [cdkConnectedOverlayOrigin]="filterOrigin"
             [cdkConnectedOverlayOpen]="isTaskListVisible" 
             [cdkConnectedOverlayPositions]="positions"
             [cdkConnectedOverlayHasBackdrop]="true" 
             [cdkConnectedOverlayBackdropClass]="'filter-transparent-backdrop'"
             (backdropClick)="closeFilter()">
             <app-notification-model data-testid="focus-navbar-notifications-panel" (closeModal)="closeFilter()"></app-notification-model>
            </ng-template>
        </li>
      <li>
        
        <span id="matMenuId" data-testid="focus-navbar-usermenu-trigger" mat-span [matMenuTriggerFor]="menu"
          [ngClass]="{'mat-menu-disabled-class': !isMatMenuAllowedToOpen}" style="display: inline-flex;color: #53565a;">
          <div>
            <p class="mb-0 text-right multiline-ellipsis text-capitalize" data-testid="focus-navbar-username-value" style="padding-right:10px;">
               {{    oauthUserName ? (oauthUserName.length > 20
                                                ? oauthUserName.slice(0, 20) + '...'
                                                : oauthUserName)
                                            : '-- --'
                }}
            </p>
            <p class="mb-0 text-right" data-testid="focus-navbar-userstatus-value" [style.color]="userStatusColor"
              style="font-size: 9px; text-transform: capitalize; line-height: 15px;font-weight: 700;letter-spacing: 1px;padding-right: 10px;">
              {{userStatus}}</p>
          </div>
          <div style=" position: relative;
            display: inline-block;">
            <img [src]="oauthUserProfilePictureUrl" (error)="onProfileImageError()" alt="" class="profileImage" data-testid="focus-navbar-profile-image" style="width: 43px;height: 43px;" />
          </div>
          <i class="fa fa-caret-down" data-testid="focus-navbar-usermenu-caret" style="margin-left: 5px;"></i>
        </span>
        <mat-menu class="mat-content translate-reset navbar-dropdown" #menu="matMenu" data-testid="focus-navbar-usermenu">
          <div style="border: none;">
            <div style="float: left">
              <img [src]="oauthUserProfilePictureUrl" (error)="onProfileImageError()" alt=""
                data-testid="focus-navbar-usermenu-profile-image" style="width: 45px; height: 45px; border-radius: 50%;margin: 5px;padding: 6px;" />
            </div>

            <div style="display: inline-block;padding: 6px;">
              <h4 style="margin: 0;text-align: left;" data-testid="focus-navbar-usermenu-name-value"> {{oauthUserName}} </h4>
              <span class="profileEmail" data-testid="focus-navbar-usermenu-email-value"> {{oauthEmailAddress}} </span>
            </div>
          </div>
          <!-- <div class="row mx-0 w-100 mat-inner-content" *ngIf="allSubPermission.InboxFocusCallTab"
            style="display:flex;border-bottom: 1px solid #DEDEDB;border-top: 1px solid #DEDEDB; padding: 16px 0;">
            <div class="col-12">
              <span class="fw-700" style="color:var(--dark-blue-grey);">Status</span>
              <div mat-menu-item class="status-title d-flex align-items-center"
                *ngIf="isTwilioWorkerEnabled && orgEntityId"
                (click)="providerChannelAvailability('TAKING_CALLS',userStatus)">
                <span class="status-indicator" style="background-color: Green;">
                  <i class="fa fa-check" aria-hidden="true"></i>
                </span> Taking Calls
              </div>
              <div mat-menu-item class="status-title d-flex align-items-center"
                *ngIf="isTwilioWorkerEnabled && orgEntityId && allPermission.OutboundDailpadGet"
                (click)="providerChannelAvailability('MAKING_CALLS',userStatus)">
                <span class="status-indicator" style="background-color: var(--focus-theme-green);">
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </span> Making Calls
              </div>
              <div mat-menu-item class="status-title d-flex align-items-center"
                (click)="providerChannelAvailability('PERSONAL',userStatus)">
                <span class="status-indicator" style="background-color: #42A3BA;"></span> Personal
              </div>
              <div mat-menu-item class="status-title d-flex align-items-center"
                (click)="providerChannelAvailability('LUNCH',userStatus)">
                <span class="status-indicator" style="background-color: #42A3BA;"></span> Lunch
              </div>
              <div mat-menu-item class="status-title d-flex align-items-center"
                (click)="providerChannelAvailability('BREAK',userStatus)">
                <span class="status-indicator" style="background-color: #42A3BA;"></span> Break
              </div>
              <div mat-menu-item class="status-title d-flex align-items-center"
                (click)="providerChannelAvailability('TRAINING',userStatus)">
                <span class="status-indicator" style="background-color:#C4314B ;">
                  <i class="fa fa-minus" aria-hidden="true"></i>
                </span> Training
              </div>
              <div mat-menu-item class="status-title d-flex align-items-center"
                (click)="providerChannelAvailability('MEETING',userStatus)">
                <span class="status-indicator" style="background:#A4B1BC"></span> Meeting
              </div>
              <div mat-menu-item class="status-title d-flex align-items-center"
                (click)="providerChannelAvailability('RECEIVING_ASSISTANCE_OTHERS',userStatus)">
                <span class="status-indicator" style="background:#A4B1BC"></span> Receiving Assistance
              </div>
              <div mat-menu-item class="status-title d-flex align-items-center"
                (click)="providerChannelAvailability('GIVING_ASSISTANCE_OTHERS',userStatus)">
                <span class="status-indicator" style="background:#A4B1BC"></span> Giving Assistance
              </div>
              <div mat-menu-item class="status-title d-flex align-items-center"
                (click)="providerChannelAvailability('TASKING_OTHERS',userStatus)">
                <span class="status-indicator" style="background:#A4B1BC"></span> Tasking
              </div>
            </div>
          </div> -->
          <footer class="col-sm-12 mat-footer" data-testid="focus-navbar-usermenu-footer" (click)="$event.stopPropagation();">
            <button id="nav-logout" data-testid="focus-navbar-logoutbtn-logout" (click)="logout()" class="col-4"
              style="background-color:#22464F;border-radius:5px;height:30px;margin-right: 4%;border:none"><span
                style="color:#FFFFFF;font-size:14px;font-weight:500;">Logout</span></button>
          </footer>
        </mat-menu>

      </li>
    </ul>
  </nav>
</header>
